import create from 'zustand'
import immer from './immer'
import { devtools } from "zustand/middleware"
import { findBatch, range } from '../utils'
let useSubjectStore = (set, get) => ({
    subjects: [],
    branch: {},
    currentAllBatches: [],
    loading: true,
    addSubject: (subject) => set((state) => void (state.subjects.push(subject))),
    getBatches: (branch) => {
        const duration = branch.eoa.length;
        const firstEoa = branch.eoa.find(e => e.year === 1);
        const firstBatch = firstEoa.currentBatch;
        return range(firstBatch - duration + 1, firstBatch);
    },
    getCurrentBatch: (branch, year) => {
        const eoaObj = branch.eoa.find(e => e.year == year);
        const currentBatch = eoaObj.currentBatch;
        return currentBatch;
    },
    setSubjectsLoading: () => set(state => void (state.loading=true)),
    initAddSubjectStore: (subs, branch) => {
        set((state) => {
            // save branch
            state.branch = branch;
            const batches = branch.eoa.map(a => a.currentBatch);
            state.currentAllBatches = batches;
            // filter out subjects with currentBatches only
            state.subjects = subs.filter(s => {
                let yearBatch = branch.eoa.filter(e => e.year == s.year)[0].currentBatch;
                return s.batches.includes(yearBatch);
            })
            state.loading=false;
        })
    },
    removeSubject: (subId) => set((state) => {
        state.subjects = state.subjects.filter((sub => sub._id !== subId));
    }),
})
useSubjectStore = devtools(useSubjectStore, { name: "subjects" });
useSubjectStore = immer(useSubjectStore);
export default create(useSubjectStore);